module.exports = __webpack_public_path__ + "static/media/gallery22.ea12bafa.png";